export const fonts = (rtl: boolean) => ({
	fonts: {
		heading: `'ManifaPro3', sans-serif`,
		body: rtl ? `'Haradh', sans-serif` : `'Ghawar', sans-serif`,
		overline: rtl ? `'ManifaPro3', sans-serif` : `'Ghawar', sans-serif`,
	}
})
